import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import env from "../../config/env";
import { useSelector } from "react-redux";
import CryptoJS from 'crypto-js';

const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

export const fetchUserData = createAsyncThunk("fetchUserData", async (id) => {
  const token = useSelector((state) => state.auth.token);

  const getEmployee = CryptoJS.SHA256("/getEmployee" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

  const userId = CryptoJS.AES.encrypt(JSON.stringify(id), SECRET_KEY).toString();
  const encodedId = encodeURIComponent(userId);

  let url = `${env.backend_api_endpoint}/${getEmployee}?id=${encodedId}`

  const response = await fetch(
    url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: token,
    },
  }
  );
  const resData = await response.json();

  if (resData?.data) {
    try {
      const bytes = CryptoJS.AES.decrypt(resData.data, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      resData.data = JSON.parse(decrypted); // ✅ replace encrypted data with decrypted JSON
    } catch (err) {
      console.error("Decryption error:", err);
      resData.data = null; // fallback if decryption fails
    }
  }

  console.log(resData, "hgjhgvjhw")

  // ✅ Return the full response (status, message, and decrypted data)
  return resData;
});

const userDataSlice = createSlice({
  name: "userData",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUserData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUserData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchUserData.rejected, (state, action) => {
      state.isError = true;
    });
  },
});

export default userDataSlice.reducer;
